import { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { showModalStateFinance } from '../state/FinanceUIStateJ';
import { securityReportState } from '../state/FinanceStateJotai';
import { AllSecuritiesGrid } from './AllSecuritiesGrid';
import { AllSecuritiesFilters } from './AllSecuritiesFilters';

export function AllSecurities() {
  const setModalState = useSetAtom(showModalStateFinance);
  const securityData = useAtomValue(securityReportState);

  useEffect(() => {
    return () => setModalState(null);
  }, [setModalState]);

  if (!securityData) {
    return null;
  }

  return <AllSecuritiesContent />;
}

function AllSecuritiesContent() {
  return (
    <>
      <AllSecuritiesFilters />
      <AllSecuritiesGrid />
    </>
  );
}
